import { IQuiz } from '../IQuiz'

export const ispIntro3: IQuiz = {
  name: 'isp-intro-3',
  question: 'В чём недостаток разделения через делегирование?',
  variants: [
    {
      text:
        'В необходимости введения новой сущности или прослойки в виде, например, адаптеров, что может увеличить сложность'
    },
    {
      text: 'В невозможности унаследовать и композировать свойства сразу от нескольких объектов'
    },
    {
      text: 'В необходимости отвязывания сущностей друг от друга и настройки их общения через посредника',
      description: 'В этом заключается цель разделения через делегирование'
    }
  ],
  meta: {
    correctAnswers: [0, 1]
  }
}
